<div class="flex-vertical oui-elevation-04 background-white rounded width-100pc padding-24 gap-32">
  <div class="flex-horizontal gap-48">
    <app-search-investisseur-autocomplete
      class="width-100pc"
      (onInvestisseurIdSelected)="onInvestisseurIdSelected($event)"
      [isRequired]="false"
      [queryMode]="'basic'"
      label="Rechercher par investisseur"></app-search-investisseur-autocomplete>
    <app-fiche-conseil-state-toggle-selector
      (filterChange)="onStateFilterChange($event)"></app-fiche-conseil-state-toggle-selector>
  </div>
  <app-fiche-conseil-table
    [inputData]="requestResult"
    (requestNewPage)="getFicheConseils()"
    [(paginationParams)]="paginationParams"></app-fiche-conseil-table>
</div>
